import { BiRepost } from "react-icons/bi";

export default function RepostsItens () {
    return (
    <>
         <BiRepost style={{ cursor: "pointer" }} />
              <a> re-post </a>
    </>
    );
}